import React, { useEffect, useState, useContext } from "react";
import { Table, Checkbox, Loader, Form, Button, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { formatDate, formatDateTime } from "../utils/misc";
import { TableContext } from "../../context-provider/TableProvider";
import Paginate from "../ui/pagination";
import useFetch from "../../hooks/use-fetch";

const ResponsesTable = ({ api, companyId }) => {
  const { activePage, recordsPerPage } = useContext(TableContext);

const getDefaultStartDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  };
  
  const getDefaultEndDate = () => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  };

 const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());

  const fetchResponses = () => {
    api.fetchData("api/customers/company_responses", "POST", {
      companyGuid: companyId,
      recordsPerPage,
      activePage,
      startDate,
      endDate,
    });
  };

  const handleDateFilter = () => {
    if (companyId) {
      fetchResponses();
    }
  };

  const clearDateFilter = () => {
    const today = new Date().toISOString().split('T')[0];
    setStartDate(today);
    setEndDate(today);
    // Fetch with today's date for both start and end
     api.setData({
      responses: [],
      total: 0
    });
  };

  useEffect(() => {
    if (companyId) {
      fetchResponses();
    }
  }, [companyId, activePage]);

  return (
    <div>
      {/* Date Range Filter */}
      <Form style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
        <Form.Group widths="equal">
          <Form.Field>
            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Form.Field>
          <Form.Field>
            <label>End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Form.Field>
          <Form.Field style={{ display: "flex", alignItems: "end", gap: "10px" }}>
            <Button primary onClick={handleDateFilter}>
              Filter
            </Button>
            <Button secondary onClick={clearDateFilter}>
              Clear
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>

      <Paginate totalRecords={api.data.total} />
      <Table celled padded>
        <Table.Header>
          <Table.Row className="semantic-header-row">
            <Table.HeaderCell>Customer</Table.HeaderCell>
            <Table.HeaderCell>Campaign</Table.HeaderCell>
            <Table.HeaderCell>Answers</Table.HeaderCell>
            <Table.HeaderCell>Response Date</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        {!api.isFetching ? (
          <Table.Body>
            {api.data.responses.map((x) => {
              return (
                <Table.Row key={x.guid}>
                  <Table.Cell>
                    <Link className="text-dark" to={`/customers/${x.customerId}`}>
                      {x.customerName}
                    </Link>
                  </Table.Cell>
                  <Table.Cell> <Link className="text-dark" to={`/subscriptions/${x.subscriptionId}`}>
                      {x.campaignName}
                    </Link>
                     
                    </Table.Cell>
                    <Table.Cell><Link 
                        rel="noopener noreferrer"
                        target="_blank"
                        to={`/customers/${x.customerId}/${x.campaignId}`}
                        style={{ marginLeft: "10px" }}
                      >
                        <Icon name="external alternate" />
                      </Link></Table.Cell>
                  <Table.Cell>{formatDateTime(x.dateResponded)}</Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        ) : (
          <Loader active />
        )}
      </Table>
    </div>
  );
};
export default ResponsesTable;